import "./stil/tokens.css";
import "./stil/grundlage.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App.tsx";
import { farbschemaBeobachten } from "./stil/farbschema.ts";

farbschemaBeobachten();

const abfragen = new QueryClient({
  defaultOptions: {
    queries: { retry: (anzahl, fehler) => anzahl < 2 && (fehler as { status?: number }).status === 0, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById("wurzel")!).render(
  <StrictMode>
    <QueryClientProvider client={abfragen}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
